import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router.js'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

import messages from './languages/messages.js'
import dateTimeFormats from "./languages/dateFormat";


//i18n
Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: "fr",
    messages,
    dateTimeFormats
});


Vue.use(BootstrapVue);

new Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app');
